import client from '../../client';
import {
  GET_CONVERSION_DATA,
  GET_CONVERSION_DATA_SUCCESS,
  GET_CONVERSION_DATA_FAIL,
  GET_CONVERSION_DRILL_DATA,
  GET_CONVERSION_DRILL_DATA_SUCCESS,
  GET_CONVERSION_DRILL_DATA_FAIL
} from '../constants/conversion';

export const getConversionData = (params, graphId) => dispatch => {
  dispatch({
    type: GET_CONVERSION_DATA,
    graphId
  });

  client
    .get('/conversions', { params })
    .then(res => {
      dispatch({
        type: GET_CONVERSION_DATA_SUCCESS,
        data: res.data,
        graphId
      });
    })
    .catch(error => {
      dispatch({
        type: GET_CONVERSION_DATA_FAIL,
        error,
        graphId
      })
    });
}

export const getConversionDrillData = (params) => dispatch => {
  dispatch({
    type: GET_CONVERSION_DRILL_DATA
  });

  client
    .get('/conversions/drill', { params })
    .then(res => {
      dispatch({
        type: GET_CONVERSION_DRILL_DATA_SUCCESS,
        data: res.data
      });
    })
    .catch(error => {
      dispatch({
        type: GET_CONVERSION_DRILL_DATA_FAIL,
        error
      })
    })
}



// WEBPACK FOOTER //
// ./src/redux/actions/conversion.js